module.exports = __webpack_public_path__ + "../assets/img/b2ba2ec87891458eaabe98cf55f8ca9b.svg";